import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/upload-files.svg'


const _hoisted_1 = { class: "form-group w-xxl-5" }
const _hoisted_2 = { class: "card upload-gallery border-0 rounded-1 p-xxl-30 p-4" }
const _hoisted_3 = { class: "file-upload text-center position-relative mb-20" }
const _hoisted_4 = {
  key: 0,
  class: "image-gallery"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-2" }, "Add Multiple Images", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_0,
          alt: "Image"
        }, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "d-block text-optional fs-14 mt-30" }, [
          _createTextVNode(" Drag & Drop Multiple Images here or "),
          _createElementVNode("span", { class: "text_secondary fw-semibold position-relative" }, " Add Image ")
        ], -1)),
        _createElementVNode("input", {
          ref: "fileInput",
          type: "file",
          class: "d-block w-100 shadow-none border-0 position-absolute start-0 end-0 top-0 bottom-0 z-1 opacity-0",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
          multiple: ""
        }, null, 544)
      ]),
      (_ctx.imagePreviews.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imagePreviews, (image, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "image-container border"
              }, [
                _createElementVNode("img", {
                  src: image,
                  alt: "Selected Image"
                }, null, 8, _hoisted_5),
                _createElementVNode("div", {
                  class: "delete-icon",
                  onClick: ($event: any) => (_ctx.removeImage(index))
                }, _cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                ]), 8, _hoisted_6)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}